<tds-footer>

<!-- ** CAN BE USED IN THE FUTURE ** -->


<!-- <div slot="top">
  <tds-footer-group title-text="Pages">
    <tds-footer-item>
      <a href="/">Home</a>
    </tds-footer-item>
    <tds-footer-item>
      <a href="/form">Form</a>
    </tds-footer-item>
  </tds-footer-group>
  <tds-footer-group title-text="Legals">
    <tds-footer-item>
      <a href="/">Terms & Conditions</a>
    </tds-footer-item>
    <tds-footer-item>
      <a href="/">Privacy policy</a>
    </tds-footer-item>
  </tds-footer-group>
  <tds-footer-group title-text="Design">
    <tds-footer-item>
      <a href="/">Grid system</a>
    </tds-footer-item>
    <tds-footer-item>
      <a href="/">Icons</a>
    </tds-footer-item>
    <tds-footer-item>
      <a href="/">Usability testing</a>
    </tds-footer-item>
    <tds-footer-item>
      <a href="/">User personas</a>
    </tds-footer-item>
  </tds-footer-group>
  <tds-footer-group title-text="Support">
    <tds-footer-item>
      <a href="/">Contact</a>
    </tds-footer-item>
    <tds-footer-item>
      <a href="/">FAQ</a>
    </tds-footer-item>
  </tds-footer-group>
</div> -->

<!-- <div slot="start">
  <tds-footer-group>
    <tds-footer-item>
      <a href="/">Link text</a>
    </tds-footer-item>
    <tds-footer-item>
      <a href="/">Link text</a>
    </tds-footer-item>
    <tds-footer-item>
      <a href="/">Link text</a>
    </tds-footer-item>
    <tds-footer-item>
      <a href="/">Link text</a>
    </tds-footer-item>
  </tds-footer-group>
</div>

<div slot="end">
  <tds-footer-group>
    <tds-footer-item>
      <a href="/">
        <tds-icon name="truck"></tds-icon>
      </a>
    </tds-footer-item>
    <tds-footer-item>
      <a href="/">
        <tds-icon name="truck"></tds-icon>
      </a>
    </tds-footer-item>
    <tds-footer-item>
      <a href="/">
        <tds-icon name="truck"></tds-icon>
      </a>
    </tds-footer-item>
  </tds-footer-group>
</div> -->
  
</tds-footer>
